import { gql, useQuery } from "@apollo/client";
import { INSTALLATION_CURRENCY } from "config";
import { useGetContactIdData } from "providers/ContactIdProvider";
import { useGetContactInfo } from "../initial/useGetContactInfo";
import { SecurityDetailsQuery } from "./types";

const SECURITY_DETAILS_QUERY = gql`
  query GetSecurityDetails(
    $securityId: Long
    $currency: String
    $filterTags: [String]
  ) {
    security(id: $securityId) {
      id
      name
      securityCode
      isinCode
      url
      url2
      currency {
        securityCode
      }
      latestMarketData {
        id
        date: obsDate
        price: closeView
      }
      type {
        id
        code
        namesAsMap
        name
      }
      securitySubType {
        code
        value
      }
      fxRate(quoteCurrency: $currency)
      tagsAsSet
      minTradeAmount
      figuresAsObject {
        latestValues
      }
      documents(filterTags: $filterTags) {
        fileName
        identifier
        mimeType
      }
      profileDataString
      profile {
        attributes {
          attributeKey
          defaultValue
        }
      }
    }
  }
`;

export const useGetSecurityDetails = (securityId: string | undefined) => {
  const { selectedContactId } = useGetContactIdData();
  const {
    data: { portfoliosCurrency } = {
      portfoliosCurrency: INSTALLATION_CURRENCY,
    },
  } = useGetContactInfo(false, selectedContactId);
  const { loading, error, data } = useQuery<SecurityDetailsQuery>(
    SECURITY_DETAILS_QUERY,
    {
      variables: {
        securityId: securityId,
        currency: portfoliosCurrency,
        filterTags: ["Online"],
      },
    }
  );
  return {
    loading,
    error,
    data: data?.security,
  };
};
